import React, { useEffect, useState } from 'react'
import { Typography } from '@material-ui/core';

import TableCustom from '../../../../../../Components/Table';

import { formatarReais } from '../../../../../../Utils/utils';
import { useStyles } from '../styles';

export default function FichaContribuicoesDescontadas({ dadosEspelho }) {

    const classes = useStyles();
    const [data, setData] = useState([]);

    useEffect(() => {
        setData(dadosEspelho.resultadosConsiderados ?? []);
    }, [dadosEspelho])

    const columns = [
        {
            title: "Competência",
            dataIndex: "competencia",
            key: "competencia",
            align: "left",
            width: 40,
            headerRender: (title) => <div style={{ paddingLeft: 12, display: 'flex' }}>
                <Typography style={{ fontSize: 12, paddingTop: 3, paddingRight: 3, fontWeight: 700 }}>{title}</Typography>
            </div>,
            render: (value, row) => <p style={{ fontSize: 13, paddingLeft: 15 }}>{value}</p>,
        },
        {
            title: "CNPJ",
            dataIndex: "cnpjEmpregador",
            key: "cnpjEmpregador",
            align: "left",
            width: 150,
            headerRender: (title) => <div style={{ display: 'flex' }}>
                <Typography style={{ fontSize: 12, paddingTop: 3, fontWeight: 700 }}>{title}</Typography>
            </div>,
            render: (value, row) => <p style={{ fontSize: 13 }}>{value !== '-' ? value : '-'}</p>,
        },
        {
            title: "Entidade Beneficente",
            dataIndex: "entidadeBeneficente",
            key: "entidadeBeneficente",
            width: 60,
            headerRender: (title) => <div style={{ display: 'flex' }}>
                <Typography style={{ fontSize: 12, paddingTop: 3, fontWeight: 700 }}>{title}</Typography>
            </div>,
            render: (value, row) => <p style={{ fontSize: 13 }}>{value ? 'Sim' : 'Não'}</p>,
        },
        {
            title: "Remuneração Recebida",
            dataIndex: "remuneracao",
            key: "remuneracao",
            headerRender: (title) => <div style={{ display: 'flex' }}>
                <Typography style={{ fontSize: 12, paddingTop: 3, fontWeight: 700 }}>{title}</Typography>
            </div>,
            render: (value, row) => <p style={{ fontSize: 13 }}>{value !== '-' ? formatarReais(value) : '-'}</p>,
        },
        {
            title: "Valor da Contribuição Descontada",
            dataIndex: "retencaoINSS",
            key: "retencaoINSS",
            headerRender: (title) => <div style={{ display: 'flex' }}>
                <Typography style={{ fontSize: 12, paddingTop: 3, fontWeight: 700 }}>{title}</Typography>
            </div>,
            render: (value, row) => <p style={{ fontSize: 13 }}>{value !== '-' ? formatarReais(value) : '-'}</p>,
        },
        {
            title: "Nome da Empresa",
            dataIndex: "origemVinculo",
            key: "origemVinculo",
            headerRender: (title) => <div style={{ display: 'flex' }}>
                <Typography style={{ fontSize: 12, paddingTop: 3, fontWeight: 700 }}>{title}</Typography>
            </div>,
            render: (value, row) => <p style={{ fontSize: 13 }}>{value}</p>,
        },
    ];

    const propsTable = {
        columns,
        data,
        heightBody: "auto",
        minHeightBody: "auto",
        marginBorder: false,
        usarMarginBottomContainer: true,
        width: '98%',
        hideBorderBottom: true,
        ativarHoverLinha: false,
        elevationPaper: 0,
        optionsToolbar: {
            info: (
                <div className={classes.header}>
                    <div className={classes.col1}>
                        <div>
                            <Typography className={classes.headerTitle}>{'Ficha Contribuições Descontadas'}</Typography>
                        </div>
                    </div>
                </div>
            ),
        },
    };

    return (
        <div>
            {data.length > 0 ?
                <TableCustom {...propsTable} />
                :
                <div style={{ display: 'flex', flexDirection: 'column', paddingLeft: 16, paddingRight: 16 }}>
                    <div className={classes.header}>
                        <div className={classes.col1}>
                            <div>
                                <Typography className={classes.headerTitle}>{'Ficha Contribuições Descontadas'}</Typography>
                            </div>
                        </div>
                    </div>
                    <div style={{ marginTop: 10, paddingLeft: 15, marginBottom: 15 }}>
                        <Typography style={{ fontSize: 13, fontWeight: 500 }}>Não há dados a serem informados</Typography>
                    </div>
                </div>
            }
        </div>
    )
}
